import { Component, Input, OnInit } from '@angular/core';
import { HealthProfessionalExportService } from '@app/modules/health-professional/services/health-professional-export.service';
import { AppToastService } from '@app/shared/services/app-toast.service';
import { NzModalRef } from 'ng-zorro-antd/modal';

const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

@Component({
  selector: 'app-modal-export-request',
  templateUrl: './modal-export-request.component.html',
  styleUrls: ['./modal-export-request.component.scss']
})
export class ModalExportRequestComponent implements OnInit {
  @Input() name: string;
  @Input() dateOfBirth: string;
  @Input() cpf: string;
  @Input() email: string;

  showEmailInput = false;
  authorize = false;
  alternativeEmail = '';
  emailInputTouched = false;
  loading = false;

  constructor(
    private ref: NzModalRef,
    private exportService: HealthProfessionalExportService,
    private notification: AppToastService
  ) {}

  get isAlternativeEmailValid() {
    return this.alternativeEmail && EMAIL_REGEX.test(this.alternativeEmail);
  }

  ngOnInit() {}

  cancel() {
    this.ref.close();
  }

  confirm() {
    this.loading = true;
    const email =
      this.showEmailInput && this.isAlternativeEmailValid ? this.alternativeEmail : this.email;
    this.exportService.requestExport(email).subscribe(
      () => {
        this.loading = false;
        this.ref.close();
        this.notification.notify(
          'success',
          'Solicitação recebida com sucesso.',
          'Você vai receber seu histórico em até 10 dias úteis.'
        );
      },
      err => {
        this.loading = false;
        this.notification.notify('error', 'Erro ao solicitar exportação', err.error.message);
      }
    );
  }
}
